import WarrantyExtensionCardComponent from "./warrantyExtensionCard.container";

export default WarrantyExtensionCardComponent;
